import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Auto-discover every locale file under ./locales/<lang>/<namespace>.json.
// Adding a new language folder or a new namespace JSON requires NO change here.
const localeContext = require.context('./locales', true, /\.json$/);

const buildResources = () => {
  const resources = {};
  const namespaces = new Set();

  localeContext.keys().forEach((key) => {
    // key looks like "./en/dashboard.json"
    const match = key.match(/^\.\/([^/]+)\/(.+)\.json$/);
    if (!match) return;

    const [, lang, namespace] = match;
    namespaces.add(namespace);

    if (!resources[lang]) resources[lang] = {};
    resources[lang][namespace] = localeContext(key);
  });

  return { resources, namespaces: Array.from(namespaces) };
};

const { resources, namespaces } = buildResources();

export const SUPPORTED_LANGUAGES = Object.keys(resources);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: namespaces,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
